import { type FC } from 'react';
import { Modal as DirectModal, type ModalProps as DirectModalProps } from '@direct-frontend/components'; // eslint-disable-line no-restricted-imports -- Разрешаем импортировать Modal
import { DEFAULT_PREVENT_SCROLL } from './constants';
import { type ModalProps } from './types';

const Modal: FC<DirectModalProps & ModalProps> = function Modal(props) {
    const {
        size: _size,
        'data-testid': dataTestId = 'Sample',
        preventScroll = DEFAULT_PREVENT_SCROLL,
        position = 'center',
        dismissOnEsc = true,
        dismissOnOutsideClick = true,
        hasCloseButton = true,
        children,
        ...other
    } = props;

    return (
        <DirectModal
            {...other}
            data-testid={`YaKitModal.${dataTestId}`}
            hasCloseButton={hasCloseButton}
            dismissOnEsc={dismissOnEsc}
            position={position}
            dismissOnOutsideClick={dismissOnOutsideClick}
            preventScroll={preventScroll}
        >
            {children}
        </DirectModal>
    );
};

export default Modal;
